import { useState } from 'react';
import { CajuClient } from 'services/caju/client';

interface AddressResponse {
    zipCode: string;
    street: string;
    additionalInfo?: string;
    neighborhood: string;
    city: string;
    state: string;
}

interface GetComplementResult {
    state?: string;
}

const notFoundMessage = 'ZipCode Not Found'

function useZipCodeComplement() {
    const [loading, setLoading] = useState<boolean>(false)

    async function getComplement(zipCode: string) {
        try {
            setLoading(true)

            const zipCodeNumber = zipCode.replace(/\D/g, '')

            const { data } = await CajuClient.get<AddressResponse>(
                `/core/sponsor-bff/v1/address/zip-code/${zipCodeNumber}`
            )

            if (!data.zipCode) {
                throw new Error(notFoundMessage)
            }

            const result: GetComplementResult = {
                state: data.state,
            }
            return result
        } catch (error) {
            throw new Error(notFoundMessage)
        } finally {
            setLoading(false)
        }
    }

    return {
        getComplement,
        loading,
    }
}

export default useZipCodeComplement
